import { Component, OnInit, ViewChild, AfterContentInit, HostListener, AfterContentChecked } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { DataService } from '../data.service';
import { Preinscripcio } from '../lib/model/preinscripcio';
import { MatStepper } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-preinscripcio',
    styleUrls: ['preinscripcio.component.css'],
    templateUrl: './preinscripcio.component.html'
})
export class PreinscripcioComponent implements OnInit, AfterContentInit {

    @ViewChild('stepper') stepper: MatStepper;
    preinscripcio: Preinscripcio;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        public dataService: DataService) {
        this.preinscripcio = dataService.preinscripcio;
        if (this.preinscripcio.oferta == null) {
            this.router.navigate(['/login']);
        }
    }

    ngOnInit() {
    }

    ngAfterContentInit () {
        try {
            if (this.stepper !== null && (!this.preinscripcio.isnew) && this.preinscripcio.estat !== 64) {
                if (this.preinscripcio.oferta.pagaInscripcio === false ) {
                    this.stepper.selectedIndex = 6;
                } else {
                    this.stepper.selectedIndex = 7;
                }
            }
        } catch (ex) {
            console.log(ex.Message);
        }
    }

    @HostListener('window:beforeunload', ['$event'])
    public unloading($event) {
        console.log('Tries to unload'); // <---- this logs to the console.
        if (this.stepper.selectedIndex === 6) {
            // En el punt 6 (pagament) no ha d'avisar perquè ha de fer una redirecció, i seria estrany i contraproduent
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/preinscripcio/preinscripcio.component.ts